import { render, staticRenderFns } from "./EkrmSpendMonths.vue?vue&type=template&id=46aff645&scoped=true&"
import script from "./EkrmSpendMonths.vue?vue&type=script&lang=js&"
export * from "./EkrmSpendMonths.vue?vue&type=script&lang=js&"
import style0 from "./EkrmSpendMonths.vue?vue&type=style&index=0&id=46aff645&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46aff645",
  null
  
)

export default component.exports